import { deleteDB } from 'idb';
import React,{useEffect,useState} from 'react'
import "../css/header.css";
import { openDB } from 'idb';
const PopupRefresh = ({ onSaveClose }) => {

    const [message, setMessage] = useState("Are You sure");
    const [messageTwo, setMessageTwo] = useState("");
    const [loading, setLoading] = useState(false);
    const saveUserRestrictions = async () => {
        let db = await openDB(
            "FoodDo",
            +localStorage.getItem("IDBVersion") || 1
        );
        let tx = db.transaction("user", "readwrite");
        let store = tx.objectStore("user");

        var usersData = await store.get(localStorage.getItem("user_uuid"));
        console.log("users", usersData)

        tx = db.transaction("role_management", "readwrite");
        store = tx.objectStore("role_management");
        let roleData = await store.getAll();
        let restrictions = roleData.find(a => a.role_uuid === usersData.role_uuid)?.restrictions || [];
        sessionStorage.setItem("restrictions", JSON.stringify(restrictions))
    }

    const getOutletDetail = () => {
        fetch("https://api.myfooddo.com/outlet/getOutletDetail", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify({
                outlet_uuid: localStorage.getItem("outlet_uuid"),
            }),
        })
            .then((res) => res.json())
            .then((content) => {
                const result = content.result;
                const stores = [
                    "running_orders",
                    "unsynced_files",
                    "Orders",
                    "reconciliation",
                ];

                console.log(result);

                result.forEach((json) => {
                    const key = Object.keys(json)[0].toLocaleLowerCase();
                    stores.push(key);
                });

                let pastVersion = +(localStorage.getItem("IDBVersion")) || 0;
                console.log("pastVersion", pastVersion);
                thisFunction(pastVersion + 1, stores, result);
            })
            .catch((err) => console.warn("error in fetching details", err));
    };

    function thisFunction(version, stores, content) {

        console.log(`opening indexeddb for version ${version}...`)
        let DBOpenReq = window.indexedDB.open("FoodDo", version);
        DBOpenReq.onerror = (err) => console.log(err);

        DBOpenReq.onupgradeneeded = (ev) => {
            console.log("currentVersion", version);
            console.log("on upgrade needed");
            let db = DBOpenReq.result;

            stores.forEach((store, i) => {
                if (!db.objectStoreNames.contains(store)) {
                    db.createObjectStore(store, {
                        keyPath: "IDENTIFIER",
                    });
                }
            });
        };

        DBOpenReq.onsuccess = (dbEvent) => {
            console.log("db open request succeed");
            let db = dbEvent.target.result;
            localStorage.setItem("IDBVersion", version);

            function addNewCollection(name, json) {
                if (name.toLowerCase().includes("outlet")) {
                    console.log(name);
                    console.log(name.toLowerCase().includes("outlet"), json);
                    localStorage.setItem("outlet-name", json.outlet_details.outlet_title);
                    localStorage.setItem("current-working-day", json.current_working_day);
                    localStorage.setItem("offline-order-upto", json.offline_order_upto);
                    getDateOrders();
                }

                let tx = db.transaction(name, "readwrite");
                if (!Array.isArray(json)) {
                    json.IDENTIFIER = json[`${name}_uuid`];
                    let store = tx.objectStore(`${name}`);
                    store.add(json);
                }

                Array.isArray(json) &&
                    json.length > 0 &&
                    json.forEach((obj, index) => {
                        if (name === "payment_modes")
                            obj.IDENTIFIER = obj.payment_mode_uuid;
                        else if (name === "seats") obj.IDENTIFIER = obj.seat_uuid;
                        else if (name === "role_management") obj.IDENTIFIER = obj.role_uuid;
                        else if (name === "item_grouping")
                            obj.IDENTIFIER = obj.item_group_uuid;
                        else obj.IDENTIFIER = obj[`${name}_uuid`] || `${index}`;

                        let store = tx.objectStore(`${name}`);
                        store.put(obj);
                    });
            }

            content.forEach((json, i) => {
                const key = Object.keys(json)[0].toLocaleLowerCase();
                addNewCollection(key, json[key]);
                if (i + 1 === content.length) {

                    sessionStorage.setItem("haveRead", true);
                    setTimeout(() => {
                        console.log("fb data injected");
                        sessionStorage.removeItem("firebase-data-injected");

                        setLoading(false);
                        onSaveClose();
                        db.close();
                    }, 1000);
                }
            });
             saveUserRestrictions();
        };

    }
    function getDateOrders() {
        let DBOpenReq = indexedDB.open(
            "FoodDo",
            +localStorage.getItem("IDBVersion") || 1
        );
        DBOpenReq.addEventListener("error", (err) => {
            console.warn(err);
        });
        DBOpenReq.addEventListener("success", (ev) => {
            let db = ev.target.result;
            let tx = db.transaction("Orders", "readwrite");
            let store = tx.objectStore("Orders");


            store.clear()


        });
        const current_working_day = +localStorage.getItem("current-working-day");
        const outlet = localStorage.getItem("outlet_uuid");
        const order_upto = localStorage.getItem("offline-order-upto");

        const working_days_collection = [];

        for (let i = 0; i < +order_upto; i++) {
            let generatedTime = new Date(current_working_day).setDate(
                new Date(current_working_day).getDate() - i
            );
            console.log(new Date(generatedTime).toUTCString());

            working_days_collection.push({
                outlet_uuid: outlet,
                working_day: generatedTime,
            });
        }

        console.log(JSON.stringify(working_days_collection));

        fetch("https://api.myfooddo.com/order/getOrderDate", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify(working_days_collection),
        })
            .then((res) => res.json())
            .then((data) => {
                let DBOpenReq = indexedDB.open(
                    "FoodDo",
                    +localStorage.getItem("IDBVersion") || 1
                );
                DBOpenReq.addEventListener("error", (err) => {
                    console.warn(err);
                });
                DBOpenReq.addEventListener("success", (ev) => {
                    let db = ev.target.result;
                    let tx = db.transaction("Orders", "readwrite");
                    let store = tx.objectStore("Orders");

                    // console.log(data);
                    // console.log(data.result);
                    data.result.forEach((collection) => {
                        collection.forEach((i) => {
                            i.IDENTIFIER = i.order_uuid;
                            i.IndexDbSts = 1;
                            // console.log(i);
                            store.put(i);
                        });
                    });
                    localStorage.setItem("refresh_status", "0");
                });
            });
    }
    const onConfirm = async() => {
        localStorage.setItem("refresh_status", "1");
        setLoading(true);
        const IDBVersion = +localStorage.getItem("IDBVersion");
        localStorage.setItem("IDBVersion", IDBVersion || 1);
        setMessage("Please Wait Data is Refreshing")
        var req = await deleteDB(
            "FoodDo",
            +localStorage.getItem("IDBVersion") || 1
            , {
                blocked() {
                    console.log("Blocked!!")
                },
            });
        console.log("request", req)
        getOutletDetail();


    };
    useEffect(() => {
        const getData = async () => {
            let DBOpenReq = indexedDB.open(
                "FoodDo",
                +localStorage.getItem("IDBVersion") || 1
            );
            DBOpenReq.addEventListener("error", (err) => {
                console.warn(err);
            });
            DBOpenReq.addEventListener("success", (ev) => {
                let tx = ev.target.result.transaction("unsynced_files", "readwrite");
                let store = tx.objectStore("unsynced_files");
                let getReq = store.getAll();
                getReq.onsuccess = (outletReq) => {
                    if (outletReq.target.result?.length) {
                        setMessage(
                            'Unable to Refresh Local Data. Some unsynced data in "unsynced_files" Table.'
                        );
                    }
                };
            });
        };
        getData();
    }, []);
    useEffect(() => {
        const getData = async () => {
            let DBOpenReq = indexedDB.open(
                "FoodDo",
                +localStorage.getItem("IDBVersion") || 1
            );
            DBOpenReq.addEventListener("error", (err) => {
                console.warn(err);
            });
            DBOpenReq.addEventListener("success", (ev) => {
                let tx = ev.target.result.transaction("running_orders", "readwrite");
                let store = tx.objectStore("running_orders");
                let getReq = store.getAll();
                getReq.onsuccess = (outletReq) => {
                    if (
                        outletReq.target.result.filter((item) => item.IsSynched !== 1)
                            .length
                    ) {
                        setMessageTwo('Some unsynced data in "running_orders" Table.');
                    }
                };
            });
        };
        getData();
    }, []);
    return (


        <div className="logoutPopup" style={{ zIndex: "9999" }}>
            <div className="logout_content">
                <h1 style={{ color: "red" }}>Warning!!!</h1>
                {message ? <div>{message}</div> : ""}
                {messageTwo ? <div>{messageTwo}</div> : ""}

                <div className="logout_button">
                    <div className="button_container">
                        {!loading ? (
                            <button
                                style={{ background: "red" }}
                                className="clear_Logout_button"
                                onClick={() => {
                                    onConfirm();
                                }}
                            >
                                Confirm
                            </button>
                        ) : (
                            <button className="clear_Logout_button" id="loading-screen">
                                <svg viewBox="0 0 100 100">
                                    <path
                                        d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                                        fill="#ffffff"
                                        stroke="none"
                                    >
                                        <animateTransform
                                            attributeName="transform"
                                            type="rotate"
                                            dur="1s"
                                            repeatCount="indefinite"
                                            keyTimes="0;1"
                                            values="0 50 51;360 50 51"
                                        ></animateTransform>
                                    </path>
                                </svg>
                            </button>
                        )}
                    </div>
                    <div className="button_container">
                        {!loading ? (
                            <button
                                className="simple_Logout_button"
                                onClick={() => onSaveClose()}
                            >
                                Cancel
                            </button>
                        ) : (
                            ""
                        )}

                    </div>
                </div>
            </div>
        </div>

    );
};


export default PopupRefresh